// Chart.js colours for the violet "Modern SaaS" palette. Every chart takes its
// colours from here. Chart.js draws on a canvas, which cannot read CSS custom
// properties, so these are the literal values of the tokens in App.css.

export const CHART_COLORS = {
  primary: '#7c3aed',
  primaryFill: 'rgba(124, 58, 237, 0.12)',
  secondary: '#b9b3d6',
  secondaryFill: 'rgba(185, 179, 214, 0.12)',
  accent: '#a78bfa',
  accentFill: 'rgba(167, 139, 250, 0.10)',
  grid: '#edeaf5',
  tick: '#a9a6bb',
  text: '#5f5c72',
  surface: '#ffffff',
  // Status series keep their meaning (delivered / failed / delayed).
  success: '#16a34a',
  successFill: 'rgba(22, 163, 74, 0.12)',
  danger: '#dc2626',
  dangerFill: 'rgba(220, 38, 38, 0.08)',
  warn: '#d97706',
  neutral: '#b9b3d6',
};

// Doughnut / pie slices without a status meaning, in order.
export const DOUGHNUT_SERIES = ['#7c3aed', '#a78bfa', '#c4b5fd', '#e4dcfd'];

// Grid lines, axis ticks (11px) and legend text for every chart.
export const applyChartDefaults = (ChartJS) => {
  ChartJS.defaults.color = CHART_COLORS.text;
  ChartJS.defaults.scale.grid.color = CHART_COLORS.grid;
  ChartJS.defaults.scale.ticks.color = CHART_COLORS.tick;
  ChartJS.defaults.scale.ticks.font = { ...(ChartJS.defaults.scale.ticks.font || {}), size: 11 };
};
